import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { NavMarker } from 'react-rhumb';
import UIFlex from 'UIComponents/layout/UIFlex';
import { AnimatedStepBody } from '../animation/StepBodyAnimations';
import { Step } from '../views/Step';
import { AccountCard } from './AccountCard';
import { ExistingUserTitle } from './ExistingUserTitle';
import { useExistingUser } from './useExistingUser';

const CmsPartnerExistingUserView = () => {
  const {
    user,
    continueWithThisUser
  } = useExistingUser();
  const stepKey = Step.ExistingUser;

  if (!user) {
    return null;
  }

  return /*#__PURE__*/_jsx(NavMarker, {
    name: `${stepKey}_VIEW`,
    children: /*#__PURE__*/_jsx(AnimatedStepBody, {
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        "data-selenium": `${stepKey}_VIEW`,
        direction: 'column',
        justify: "center",
        wrap: "nowrap",
        children: [/*#__PURE__*/_jsx(ExistingUserTitle, {
          user: user
        }), /*#__PURE__*/_jsx(AccountCard, {
          continueWithThisUser: continueWithThisUser
        })]
      })
    })
  });
};

export default CmsPartnerExistingUserView;